/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState, useMemo } from "react";
import { Link, useNavigate } from "react-router-dom";
import Cookies from 'js-cookie'

import notificationIcon from '../assets/images/notification.svg';
import userIcon from '../assets/images/user-icon.png';

import styles from "../assets/css/topbar.module.css";
import { adminGet } from "../api/adminUser";
function TopBar() {
  const navigate = useNavigate()
  const [openDropdown, setOpenDropdown] = useState(false);
  const [userImage, setUserImage] = useState(localStorage.getItem('userImage') || '');
  const dropdownRef = useRef(null);
  const userData = useMemo(() => JSON.parse(Cookies.get('adminUserData') || null), [])

  // Close when clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpenDropdown(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);


  useEffect(() => {
    const getData = async () => {
      if (userData?.mediaId) {
        const response = await adminGet(userData?.adminUserId)
        if (response?.data) {
          const imageUrl = response?.data?.media?.url
          setUserImage(imageUrl)
          localStorage.setItem('userImage', imageUrl)
        }
      }
    }
    if(userData){
      getData()
    }

  }, [])

  useEffect(() => {
    const handleImageUpdate = () => {
      setUserImage(localStorage.getItem('userImage') || '')
    }
    window.addEventListener('userImageUpdated', handleImageUpdate)
    return () => window.removeEventListener('userImageUpdated', handleImageUpdate)
  }, [])

  return (
    <div className={`topbar-container ${styles.topbarContainer}`}>
      <div className={styles.topbarLeft}>
        <h2>Admin</h2>
      </div>

      <div className={styles.rightSearchbar}>
        <div className={styles.topbarRight}>

          <div className={styles.notificationIcon}>
            <img src={notificationIcon} alt="notification" />
          </div>

          {/* WRAP user icon + dropdown inside ref */}
          <div className={styles.userWrapper} ref={dropdownRef}>

            <div
              className={styles.userIcon}
              onClick={() => setOpenDropdown(prev => !prev)}
            >
              <img src={userImage || userIcon} alt="user-icon" />
            </div>

            {openDropdown && (
              <div className={styles.userDropdown}>
                <div className={styles.dropdownHeader}>
                  <div className={styles.userProfileImage}>
                    <Link to='/setting'>
                      <img src={userImage || userIcon} alt="profile" />
                    </Link>
                  </div>
                  <div>
                    <Link to='/setting'>
                      <p>{userData.name || 'Admin'}</p>
                      <p>{userData.email || 'admin@example.com'}</p>
                    </Link>
                  </div>
                </div>

                <button className={styles.logoutBtn} onClick={() => {
                  Cookies.remove('adminUserData')
                  Cookies.remove('adminToken')
                  localStorage.removeItem('userImage')
                  navigate('/login')
                }}>Logout</button>
              </div>
            )}

          </div>

        </div>
      </div>
    </div>
  );
}

export default TopBar;
